







import Vue from "vue";
import {UtilityHelper} from "@/helpers/UtilityHelper";

export default Vue.extend({
  name: "logo",
  computed: {
    UtilityHelper() {
      return UtilityHelper
    }
  },
});
